import {
  ItemsContext_VariantsPackFieldsFragment,
  VolumePromotionsContext_PromotionEffectFieldsFragment,
  VolumePromotionsContext_PromotionQualificationFieldsFragment,
  VolumePromotionsContext_VolumePromotionFieldsFragment,
} from '@/types';

export enum PromotionDiscountType {
  Promotion = 'PROMOTION',
  Rebate = 'REBATE',
  Volume = 'VOLUME',
}

export enum PromotionLevel {
  Order = 'ORDER',
  Pack = 'PACK',
}

export interface PromotionEffectMetadata {
  discount_in_micros?: number | null;
  discount_percentage?: number | null;
  level: PromotionLevel;
  num_affected?: number | null;
  pack_price_in_micros?: number | null;
}

export interface PromotionQualificationMetadata {
  acc_over_days?: number | null;
  discount_code?: string | null;
  exact_num_packs?: number | null;
  fulfillment_date?: string | null;
  level: PromotionLevel;
  min_packs?: number | null;
  min_spend_in_micros?: number | null;
  min_weeks?: number | null;
}

export interface PromotedVariantPackInfo {
  discountInMicros?: number | null;
  discountPercentage?: number | null;
  numAffected?: number | null;
  packPriceInMicros?: number | null;
  photoURLs: string[];
  variantPack: ItemsContext_VariantsPackFieldsFragment;
}

export interface Promotion {
  backgroundColorEnd: string;
  backgroundColorStart: string;
  backgroundImageUrl?: string | null;
  discountType: PromotionDiscountType;
  effectLevel?: PromotionLevel;
  expiresAt?: string | null;
  hideMarketingTile: boolean;
  hideTagline: boolean;
  marketingText?: string | null;
  sortOrder?: number | null;
  startsAt: string;
  supplierTimezone: string;
  tagline?: string | null;
  uuid: string;
}

export interface VolumePromotion extends Promotion {
  promotedVariantPacks: PromotedVariantPackInfo[];
}

export interface VariantPackVolumePromotion extends Promotion {
  isSatisfiedBySinglePack: boolean;
  minPacks?: number | null;
  promotedVariantPackInfo: PromotedVariantPackInfo;
}

export interface PromotionComponentGroup {
  promotion_effect?: VolumePromotionsContext_PromotionEffectFieldsFragment | null;
  promotion_effect_variant_pack_ids: Set<string>;
  promotion_qualifications: VolumePromotionsContext_PromotionQualificationFieldsFragment[];
  uuid: string;
  variant_packs: ItemsContext_VariantsPackFieldsFragment[];
}

export interface RestaurantPromotion {
  promotion?: VolumePromotionsContext_VolumePromotionFieldsFragment;
  promotion_component_groups?: PromotionComponentGroup[];
  promotion_effect?: VolumePromotionsContext_PromotionEffectFieldsFragment | null;
  promotion_qualification?: VolumePromotionsContext_PromotionQualificationFieldsFragment | null;
  variant_pack?: ItemsContext_VariantsPackFieldsFragment;
}
